up.compiler('[datetime-picker]', element => {

  let timePickerInput = element.querySelector('[time-picker]')

  let onChange = (event) => {
    if (event.value) {
      // A timeout is required for the time picker to properly appear
      setTimeout(() => timePickerInput.focus())
    } else {
      timePickerInput.value = ''
    }
  }

  element.addEventListener('date-picker:change', onChange)

})
